<template>
  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">
      <div class="etx-flex Flex tab-s:gv-0">
        <div class="etx-flex__item Flex__item tab-s:c-0 show-0 tab-s:show-1">
          <div class="BrandshapeWrapper falling-off-left desk-l:falling-off-max-left" :class="entranceClassList">
            <div class="Brandshape" :data-color-main="stripeColorMain" :data-color-accent="stripeColorAccent">
              <svg width="208" height="208">
                <use :xlink:href="stripeShape"></use>
              </svg>
            </div>
          </div>
        </div>

        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-8 tab-s:ml-2 tab-m:ml-3 tab-l:ml-4">
          <div class="etx-text Text" :class="entranceClassList" v-if="heading || lead || text">
            <h2 v-if="headingType == 'h2'" :class="headingStyle !== 'standard' ? headingStyle : ''">
              {{ heading }}
            </h2>
            <h3 v-if="headingType == 'h3'" :class="headingStyle !== 'standard' ? headingStyle : ''">
              {{ heading }}
            </h3>
            <h4 v-if="headingType == 'h4'" :class="headingStyle !== 'standard' ? headingStyle : ''">
              {{ heading }}
            </h4>
            <p v-if="lead" class="font-lead" v-html="lead.replace(/\n/g, '<br>')"></p>
            <HelperHtmlRenderer :htmlContent="text" />
          </div>

          <div class="etx-spacer Spacer h-50"></div>

          <div id="location-overview-form" class="Form" :class="entranceClassList">
            <LocationSearchBar ref="searchBarRef" :useAsFilter="true" @searchResult="handleSearchResult" />

            <div class="etx-spacer Spacer h-50"></div>

            <div class="FilterCollapsed" :class="[true ? 'active' : '']" v-if="
              filteredRegions?.length ||
              filteredOrganisations?.length ||
              sortedCompetencies?.length ||
              filteredServices?.length
            ">
              <div class="FilterCollapsed__content" style="display: block !important">
                <div class="etx-flex Flex gv-150">
                  <!-- Regions Filter -->
                  <div class="RegionsFilter etx-flex__item Flex__item tab-s:c-6" v-if="filteredRegions?.length">
                    <div class="FormField select">
                      <div class="FormField__input">
                        <div class="CustomSelect">
                          <input type="hidden" name="categories" />

                          <div class="CustomSelect__total"></div>

                          <div class="CustomSelect__trigger">
                            <div class="CustomSelect__trigger__label etx-text-crop line-1">
                              Region
                            </div>
                          </div>

                          <div class="CustomSelect__drawer">
                            <div class="CustomSelect__header">
                              <div class="CustomSelect__header__text">
                                <span class="etx-text-crop line-1">Region</span>
                              </div>

                              <div class="CustomSelect__header__close">
                                <i class="far fa-arrow-up-long"></i>
                              </div>
                            </div>

                            <ul class="CustomSelect__options">
                              <li>
                                <label for="CUSTOMSELECT_REGION_ELEMENT_1">
                                  <input type="checkbox" id="CUSTOMSELECT_REGION_ELEMENT_1" name="" value="" />
                                  <span>Zürich</span>
                                </label>
                              </li>

                              <li>
                                <label for="CUSTOMSELECT_REGION_ELEMENT_2">
                                  <input type="checkbox" id="CUSTOMSELECT_REGION_ELEMENT_2" name="" value="" />
                                  <span>Ostschweiz</span>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Organisations Filter -->
                  <div class="OrganisationFilter etx-flex__item Flex__item tab-s:c-6"
                    v-if="filteredOrganisations?.length">
                    <div class="FormField select">
                      <div class="FormField__input">
                        <div class="CustomSelect">
                          <input type="hidden" name="categories" />

                          <div class="CustomSelect__total"></div>

                          <div class="CustomSelect__trigger">
                            <div class="CustomSelect__trigger__label etx-text-crop line-1">
                              {{ $texts('organisations.label', 'Unternehmen') }}
                            </div>
                          </div>

                          <div class="CustomSelect__drawer">
                            <div class="CustomSelect__header">
                              <div class="CustomSelect__header__text">
                                <span class="etx-text-crop line-1">{{
                                  $texts('organisations.label', 'Unternehmen')
                                  }}</span>
                              </div>

                              <div class="CustomSelect__header__close">
                                <i class="far fa-arrow-up-long"></i>
                              </div>
                            </div>

                            <ul class="CustomSelect__options">
                              <li v-for="organisation in filteredOrganisations" :key="organisation.tid">
                                <label :for="`organisation_${organisation.tid}`">
                                  <input type="checkbox" :id="`organisation_${organisation.tid}`"
                                    :value="organisation.tid" @change="
                                      toggleOrganisationFilter(organisation)
                                      " :checked="isOrganisationSelected(organisation)
                                      " />
                                  <span>{{ organisation.name }}</span>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Competencies Filter -->
                  <div class="CompetenciesFilter etx-flex__item Flex__item tab-s:c-6"
                    v-if="false && sortedCompetencies?.length">
                    <div class="FormField select Competencies">
                      <div class="FormField__input">
                        <div class="CustomSelect">
                          <input type="hidden" name="categories" />

                          <div class="CustomSelect__total"></div>

                          <div class="CustomSelect__trigger">
                            <div class="CustomSelect__trigger__label etx-text-crop line-1">
                              {{ $texts('competencies.label', 'Kompetenzen') }}
                            </div>
                          </div>

                          <div class="CustomSelect__drawer">
                            <div class="CustomSelect__header">
                              <div class="CustomSelect__header__text">
                                <span class="etx-text-crop line-1">{{
                                  $texts('competencies.label', 'Kompetenzen')
                                  }}</span>
                              </div>

                              <div class="CustomSelect__header__close">
                                <i class="far fa-arrow-up-long"></i>
                              </div>
                            </div>

                            <ul class="CustomSelect__options">
                              <li v-for="competency in sortedCompetencies" :key="competency.tid" :class="{
                                'sub-level': competency.parent.length > 0,
                              }">
                                <label :for="`competency_${competency.tid}`">
                                  <input type="checkbox" :id="`competency_${competency.tid}`" :value="competency.tid"
                                    @change="toggleCompetencyFilter(competency)"
                                    :checked="isCompetencySelected(competency)" />
                                  <span>{{ competency.name }}</span>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Services Filter -->
                  <div class="ServicesFilter etx-flex__item Flex__item tab-s:c-6" v-if="filteredServices?.length">
                    <div class="FormField select">
                      <div class="FormField__input">
                        <div class="CustomSelect">
                          <input type="hidden" name="categories" />

                          <div class="CustomSelect__total"></div>

                          <div class="CustomSelect__trigger">
                            <div class="CustomSelect__trigger__label etx-text-crop line-1">
                              Service & Unterhalt
                            </div>
                          </div>

                          <div class="CustomSelect__drawer">
                            <div class="CustomSelect__header">
                              <div class="CustomSelect__header__text">
                                <span class="etx-text-crop line-1">Service & Unterhalt</span>
                              </div>

                              <div class="CustomSelect__header__close">
                                <i class="far fa-arrow-up-long"></i>
                              </div>
                            </div>

                            <ul class="CustomSelect__options">
                              <li>
                                <label for="CUSTOMSELECT_SERVICE_ELEMENT_1">
                                  <input type="checkbox" id="CUSTOMSELECT_SERVICE_ELEMENT_1" name="" value="" />
                                  <span>Service & Unterhalt #1</span>
                                </label>
                              </li>

                              <li>
                                <label for="CUSTOMSELECT_SERVICE_ELEMENT_2">
                                  <input type="checkbox" id="CUSTOMSELECT_SERVICE_ELEMENT_2" name="" value="" />
                                  <span>Service & Unterhalt #2</span>
                                </label>
                              </li>

                              <li>
                                <label for="CUSTOMSELECT_SERVICE_ELEMENT_3">
                                  <input type="checkbox" id="CUSTOMSELECT_SERVICE_ELEMENT_3" name="" value="" />
                                  <span>Service & Unterhalt #3</span>
                                </label>
                              </li>

                              <li>
                                <label for="CUSTOMSELECT_SERVICE_ELEMENT_4">
                                  <input type="checkbox" id="CUSTOMSELECT_SERVICE_ELEMENT_4" name="" value="" />
                                  <span>Service & Unterhalt #4</span>
                                </label>
                              </li>

                              <li>
                                <label for="CUSTOMSELECT_SERVICE_ELEMENT_5">
                                  <input type="checkbox" id="CUSTOMSELECT_SERVICE_ELEMENT_5" name="" value="" />
                                  <span>Service & Unterhalt #5</span>
                                </label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="etx-spacer Spacer h-50"></div>

                <button class="etx-button Button"
                style="margin-bottom:30px"
                  @click="removeAllFilters()" v-if="
                    selectedOrganisationFilters.length > 0 ||
                    selectedCompetencyFilters.length > 0 ||
                    distanceFilter
                  ">
                  <div class="etx-button__text Button__text">
                    <span>{{ $texts('location_search.remove_all_filters', 'Alle Filter entfernen') }}</span>
                  </div>
                  <div class="etx-button__icon Button__icon">
                    <!-- <i class="far fa-xmark"></i> -->
                    <i class="far fa-long-arrow-right"></i>
                  </div>
                </button>

                <div class="TagList">
                  <div v-for="filter in selectedOrganisationFilters" :key="filter.tid" class="Tag removable"
                    @click="removeOrganisationFilter(filter)">
                    <i class="far fa-times"></i>
                    <span>{{ filter.name }}</span>
                  </div>
                  <div v-for="filter in selectedCompetencyFilters" :key="filter.tid" class="Tag removable"
                    @click="removeCompetencyFilter(filter)">
                    <i class="far fa-times"></i>
                    <span>{{ filter.name }}</span>
                  </div>
                </div>
              </div>

              <!-- <div class="FilterCollapsed__button">

                <button class="etx-button Button minimal">
                  <div class="etx-button__text Button__text">
                    <span>{{ $texts('location_search.location_filter', 'Standorte filtern') }}</span>
                  </div>
                  <div class="etx-button__icon Button__icon">
                    <i class="far fa-long-arrow-down"></i>
                  </div>
                </button>

              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div v-if="allLocationsData?.length === 0" class="message message-warning" style="margin-bottom: 3rem">
        {{
          $texts(
            'location_search.no_results',
            'Keine Ergebnisse gefunden. Bitte passen Sie Ihre Suchkriterien an.',
          )
        }}
      </div>

      <div class="LocationFinder">
        <div class="LocationFinder__map">
          <div class="FixedRatio ratio-3-2 falling-off-left falling-off-right">
            <ClientOnly>
              <div class="GoogleMaps" id="google-maps-overview" ref="googleMapsRef"></div>
            </ClientOnly>
          </div>
        </div>

        <div class="LocationFinder__details">
          <Transition name="slide-fade">
            <div class="etx-card Card CardMapContact bg-white has-shadow" v-if="selectedLocation">
              <div class="etx-card__item Card__item ph-150 pv-150 tab-s:ph-200 tab-s:pv-200 tab-m:pl-0">
                <div class="etx-flex Flex gv-150 tab-l:nowrap">
                  <div class="etx-flex__item Flex__item c-auto tab-m:grow-1 tab-m:shrink-0 o-1 tab-m:o-2 tab-l:o-4">
                    <div class="CardMapContact__close" @click="closeLocationDetails">
                      <div class="etx-icon Icon large">
                        <i class="fal fa-times"></i>
                      </div>
                    </div>
                  </div>

                  <div
                    class="etx-flex__item Flex__item c-9 grow-1 tab-s:c-10 tab-m:c-4 tab-m:grow-0 tab-l:c-3 tab-m:ml-1">
                    <div class="etx-text Text">
                      <p>
                        <span class="font-color-primary font-weight-bold font-size-large">
                          {{ selectedLocation?.address?.organization }} </span><br />
                        {{ selectedLocation?.address?.addressLine1 }}<br />
                        {{ selectedLocation?.address?.postalCode }}
                        {{ selectedLocation?.address?.locality }},
                        {{ selectedLocation?.address?.countryCode }}
                      </p>
                    </div>

                    <div class="etx-item-list ItemList contact">
                      <a v-if="selectedLocation?.phone1" class="etx-item Item" :href="`tel:${selectedLocation?.phone1}`"
                        title="">
                        <div class="etx-item__icon Item__icon">
                          <i class="fal fa-phone"></i>
                        </div>
                        <div class="etx-item__text Item__text">
                          <span>{{
                            formatSwissPhoneNumber(selectedLocation?.phone1)
                            }}</span>
                        </div>
                      </a>

                      <a v-if="selectedLocation?.email1" class="etx-item Item"
                        :href="`mailto:${selectedLocation?.email1}`" title="">
                        <div class="etx-item__icon Item__icon">
                          <i class="fal fa-envelope"></i>
                        </div>
                        <div class="etx-item__text Item__text">
                          <span>{{ selectedLocation?.email1 }}</span>
                        </div>
                      </a>
                    </div>

                    <div class="etx-button-list ButtonList">
                      <a v-if="selectedLocation?.alias" class="etx-button Button"
                        :href="getLocationUrl(selectedLocation)" title="">
                        <div class="etx-button__text Button__text">
                          <span>{{
                            $texts(
                              'location_search.detail_page',
                              'Zur Detailseite',
                            )
                          }}</span>
                        </div>
                        <div class="etx-button__icon Button__icon">
                          <i class="far fa-long-arrow-right"></i>
                        </div>
                      </a>

                      <a v-if="locationSearchContactPageLink" class="etx-button Button minimal"
                        :href="locationSearchContactPageLink" title="">
                        <div class="etx-button__text Button__text">
                          <span>{{
                            $texts(
                              'location_search.contact_form',
                              'Zum Kontaktformular',
                            )
                          }}</span>
                        </div>
                        <div class="etx-button__icon Button__icon">
                          <i class="far fa-long-arrow-right"></i>
                        </div>
                      </a>
                    </div>
                  </div>

                  <div
                    class="etx-flex__item Flex__item c-9 grow-1 tab-s:c-10 tab-m:c-4 tab-m:grow-0 tab-l:c-3 tab-m:ml-1 tab-l:ml-0 o-2 tab-m:o-1">
                    <LocationContactOpeningHours :openingHours="selectedLocation?.openingHours" />
                  </div>

                  <div class="etx-flex__item Flex__item tab-l:c-4 tab-m:grow-1 tab-m:shrink-1 tab-m:ml-1 o-2 tab-m:o-3">
                    <template v-if="selectedLocation?.competencies?.length">
                      <div class="etx-text Text">
                        <p class="font-size-large font-weight-bold">
                          <!-- {{ selectedLocation?.competenciesLabel }} -->
                          {{ $texts('competencies.label', 'Kompetenzen') }}
                        </p>
                      </div>

                      <div class="etx-tag-list TagList">
                        <a v-for="taxonomy in selectedLocation?.competencies"
                          :href="taxonomy?.externalLink?.uri?.path ? taxonomy?.externalLink?.uri?.path : taxonomy?.link?.url?.path"
                          :target="taxonomy?.externalLink?.uri?.path && '_blank'" :title="taxonomy?.name"
                          class="etx-tag Tag">
                          <div class="etx-tag__text Tag__text">
                            <span>{{ taxonomy?.name }}</span>
                          </div>
                        </a>
                      </div>
                    </template>

                    <div v-if="
                      selectedLocation?.competencies?.length &&
                      selectedLocation?.services?.length
                    " class="etx-spacer Spacer h-25"></div>

                    <template v-if="selectedLocation?.services?.length">
                      <div class="etx-text Text">
                        <p class="font-size-large font-weight-bold">
                          {{ selectedLocation?.servicesLabel }}
                        </p>
                      </div>

                      <div class="etx-tag-list TagList">
                        <a v-for="taxonomy in selectedLocation?.services"
                          :href="taxonomy?.externalLink?.uri?.path ? taxonomy?.externalLink?.uri?.path : taxonomy?.link?.url?.path"
                          :target="taxonomy?.externalLink?.uri?.path && '_blank'" :title="taxonomy?.name"
                          class="etx-tag Tag">
                          <div class="etx-tag__text Tag__text">
                            <span>{{ taxonomy?.name }}</span>
                          </div>
                        </a>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getDistance } from 'geolib'

const props = defineProps<{
  heading?: string
  headingType: string
  headingStyle: string
  lead?: string
  text?: string
  stripe: string
}>()

const { options, isEditing } = defineBlokkli({
  bundle: 'locations_overview',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
  editor: {
    maxInstances: 1,
  },
})

const { $texts } = useNuxtApp()
const currentLanguage = useCurrentLanguage()
const { getCrossSiteUrl, requiresCrossSiteUrl } = useCrossSiteUrl()

const paragraphClassList = computed(() => {
  const classList = []
  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }
  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }
  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }
  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

const stripeShape = computed(() => `#brandshape-${props.stripe.split('_')[0]}`)
const stripeColorMain = computed(() => props.stripe.split('_')[1])
const stripeColorAccent = computed(() => props.stripe.split('_')[2])

// Computed property for generating the correct location URL
const getLocationUrl = computed(() => {
  return (location: any) => {
    if (!location?.alias) return '#'

    const langcode = location.langcode ?? currentLanguage.value
    const domainId = location?.domain?.id || ''
    const currentTenantId = tenantId || ''

    // Check if this location requires a cross-site URL (different domain)
    if (requiresCrossSiteUrl(domainId, currentTenantId)) {
      return getCrossSiteUrl(domainId, langcode, location.alias)
    }

    // Default relative URL for same-site locations or when domain ID is invalid
    return `/${langcode}${location.alias}`
  }
})

/*
 * The search part
 */
const tenantId = useTenant()
const queryName = tenantId === 'equans' ? 'getAllLocationCoords' : 'getAllLocationCoordsTenant'
const { data: allLocationsDataOriginal } = await useAsyncData(
  `getAllLocationCoords-${tenantId}`,
  async () => {
    const result = await useGraphqlQuery(queryName, {
      tenantId: tenantId,
    })
    const items = result.data?.entityQuery?.items ?? []
    return items
  },
)

const { data: organisationsData } =
  tenantId !== 'equans'
    ? { data: [] }
    : await useAsyncData(`getOrganisations`, async () => {
      const result = await useGraphqlQuery('getTaxonomyFilters', {
        vid: 'organisations',
      })
      const items = result.data?.entityQuery?.items ?? []
      return items
    })

const { data: competenciesData } = await useAsyncData(
  `getCompetencies-${tenantId}`,
  async () => {
    const vid = tenantId ? 'competencies' : 'competencies_kuma'
    const result = await useGraphqlQuery('getTaxonomyFilters', { vid: vid })
    const items = result.data?.entityQuery?.items ?? []
    return items
  },
)

// Perform here preprocessing of the items to filter according to the form fields
const allLocationsData = ref(
  JSON.parse(JSON.stringify(allLocationsDataOriginal.value)),
)
const googleMapsRef = ref(null)
const selectedLocation = ref(null)
const selectedOrganisationFilters = ref([])
const selectedCompetencyFilters = ref([])
const distanceFilter = ref(null)

const initData: Ref<InitData> = await useInitData()
const { globalConfig } = initData.value
const { locationSearchContactPage } = globalConfig
const locationSearchContactPageLink = ref(
  locationSearchContactPage?.uri?.path || '/',
)

const runtimeConfig = useRuntimeConfig()
const gMapApiKey = runtimeConfig.public.scripts.googleMaps.apiKey
let mapInstance = null
let markers = []

import customMapStyles from '~/assets/gmap/mapStyles.json'
import customMarkerIcon from '~/assets/symbols/location-pin.svg'

/// <reference types="google.maps" />
const { onLoaded: onGMapLoaded } = useScriptGoogleMaps({
  apiKey: gMapApiKey,
})

const searchBarRef = ref(null)

onMounted(() => {
  if (typeof initFilterCollapsed === 'function') {
    initFilterCollapsed()
  }
  if (typeof initFilters === 'function') {
    initFilters()
  }

  onGMapLoaded(async (instance) => {
    const maps = (await instance.maps) as any as typeof google.maps // upstream google type issue
    initGoogleMaps(maps)

    const route = useRoute()
    if (route?.query?.lat && route?.query?.lng) {
      const lat = parseFloat(route.query.lat)
      const lng = parseFloat(route.query.lng)
      if (!isNaN(lat) && !isNaN(lng)) {
        distanceFilter.value = { lat, lng }
        applyFilters()
      }
    }
  })
})

function initGoogleMaps(maps) {
  if (!googleMapsRef.value) return

  const mapOptions = {
    center: { lat: 46.7985, lng: 8.2318 }, // Center on Switzerland
    zoom: 8,
    disableDefaultUI: true,
    zoomControl: true,
    styles: customMapStyles,
    clickableIcons: false,
    minZoom: 7,
    maxZoom: 19,
    // restriction: {
    //   latLngBounds: {
    //     north: 49.0507, // 46.7985 + (250 / 111) ~ 51.1985
    //     south: 44.5462, // 46.7985 - (250 / 111) ~ 42.3985
    //     west: 0, // 8.2318 - (600 / (111 * cos(46.7985))) ~ 1.6318
    //     east: 14.8318, // 8.2318 + (600 / (111 * cos(46.7985))) ~ 14.8318
    //   },
    // },
  }

  mapInstance = new maps.Map(googleMapsRef.value, mapOptions)

  drawMarkers(allLocationsData.value)
}

function drawMarkers(locations) {
  // Clear existing markers
  markers.forEach((marker) => marker.setMap(null))
  markers = []

  // Add new markers based on the filtered data
  locations.forEach((location) => {
    const marker = new google.maps.Marker({
      position: location.coordinates,
      map: mapInstance,
      title: location.title,
      icon: customMarkerIcon,
    })

    marker.addListener('click', () => {
      showLocationDetails(location)
    })

    markers.push(marker)
  })

  centerMapOnLocations(markers)
}

function showLocationDetails(location) {
  fetchLocationDetails(location.id).then((data) => {
    selectedLocation.value = data
    scrollToTarget()
  })
}

function scrollToTarget(elementId = 'google-maps-overview') {
  const targetElement = document.getElementById(elementId)
  const headerElement = document.getElementById('header')
  if (targetElement) {
    const headerHeight = headerElement ? headerElement.offsetHeight : 80
    const offsetPosition =
      targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }
}

async function fetchLocationDetails(locationId) {
  const queryVars = {
    nid: [locationId],
  }
  const result = await useGraphqlQuery('getLocation', queryVars)
  const items = result.data?.entityQuery?.items ?? []
  return items.length > 0
    ? {
      title: items[0].title,
      email1: items[0].email1,
      phone1: items[0].phone1,
      address: items[0].address,
      langcode: items[0].langcode,
      alias: items[0].path.alias,
      coordinates: items[0].coordinates,
      openingHours: items[0].openingHours,
      competencies: items[0].competencies,
      competenciesLabel: items[0].competencies[0]?.vid?.name,
      services: items[0].services,
      servicesLabel: items[0].services[0]?.vid?.name,
      domain: items[0]?.domain?.id,
    }
    : {}
}

function closeLocationDetails() {
  selectedLocation.value = null
}

function applyFilters() {
  let filteredData = JSON.parse(JSON.stringify(allLocationsDataOriginal.value))

  if (selectedOrganisationFilters.value?.length > 0) {
    filteredData = filterByOrganisations(filteredData)
  }

  if (selectedCompetencyFilters.value?.length > 0) {
    filteredData = filterByCompetencies(filteredData)
  }

  if (filteredData.length > 0 && distanceFilter.value) {
    let filteredDataLocTemp = filterByDistance(
      filteredData,
      distanceFilter.value,
    )
    if (filteredDataLocTemp.length === 0) {
      filteredDataLocTemp = findClosestLocations(
        filteredData,
        distanceFilter.value,
        3,
      )
    }
    filteredData = filteredDataLocTemp
  }

  allLocationsData.value = filteredData
  drawMarkers(filteredData)
  if (filteredData.length) {
    scrollToTarget('location-overview-form')
  }
}

function filterByDistance(locations, point) {
  const maxDistance = 25000 // 25 km in meters
  return locations
    .filter(
      (location) => location?.coordinates?.lat && location?.coordinates?.lng,
    )
    .map((location) => {
      const locationPoint = {
        latitude: location.coordinates.lat,
        longitude: location.coordinates.lng,
      }
      const distance = getDistance(point, locationPoint)
      return {
        ...location,
        distance,
      }
    })
    .filter((location) => location.distance <= maxDistance)
}

function findClosestLocations(locations, point, limit) {
  return locations
    .filter(
      (location) => location?.coordinates?.lat && location?.coordinates?.lng,
    )
    .map((location) => {
      const locationPoint = {
        latitude: location.coordinates.lat,
        longitude: location.coordinates.lng,
      }
      const distance = getDistance(point, locationPoint)
      return {
        ...location,
        distance,
      }
    })
    .sort((a, b) => a.distance - b.distance)
    .slice(0, limit)
}

function filterByOrganisations(locations) {
  return locations.filter((location) => {
    return selectedOrganisationFilters.value.some((filter) =>
      location.organisations.some((org) => org.tid === filter.tid),
    )
  })
}

function filterByCompetencies(locations) {
  return locations.filter((location) => {
    return selectedCompetencyFilters.value.some((filter) =>
      location.competencies.some((comp) => comp.tid === filter.tid),
    )
  })
}

function handleSearchResult(result) {
  closeLocationDetails()
  if (!result) {
    distanceFilter.value = null
  } else {
    distanceFilter.value = {
      lat: result.location.lat,
      lng: result.location.lng,
    }
  }
  applyFilters()
}

function isOrganisationSelected(organisation) {
  return selectedOrganisationFilters.value.some(
    (filter) => filter.tid === organisation.tid,
  )
}

function toggleOrganisationFilter(organisation) {
  const index = selectedOrganisationFilters.value.findIndex(
    (filter) => filter.tid === organisation.tid,
  )
  if (index === -1) {
    selectedOrganisationFilters.value.push(organisation)
  } else {
    selectedOrganisationFilters.value.splice(index, 1)
  }
  applyFilters()
}

function removeOrganisationFilter(organisation) {
  const index = selectedOrganisationFilters.value.findIndex(
    (filter) => filter.tid === organisation.tid,
  )
  if (index !== -1) {
    selectedOrganisationFilters.value.splice(index, 1)
  }
  applyFilters()
}

function isCompetencySelected(competency) {
  return selectedCompetencyFilters.value.some(
    (filter) => filter.tid === competency.tid,
  )
}

function toggleCompetencyFilter(competency) {
  const index = selectedCompetencyFilters.value.findIndex(
    (filter) => filter.tid === competency.tid,
  )
  if (index === -1) {
    selectedCompetencyFilters.value.push(competency)
  } else {
    selectedCompetencyFilters.value.splice(index, 1)
  }
  applyFilters()
}

function removeCompetencyFilter(competency) {
  const index = selectedCompetencyFilters.value.findIndex(
    (filter) => filter.tid === competency.tid,
  )
  if (index !== -1) {
    selectedCompetencyFilters.value.splice(index, 1)
  }
  applyFilters()
}

function removeAllFilters() {
  selectedOrganisationFilters.value = []
  selectedCompetencyFilters.value = []
  distanceFilter.value = null
  searchBarRef.value?.onResultReset()
  applyFilters()
}

const sortedCompetencies = computed(() => {
  // Collect TIDs used by locations
  const usedCompetencyTids = new Set()
  allLocationsDataOriginal.value.forEach((location) => {
    location?.competencies?.forEach((c) => usedCompetencyTids.add(c.tid))
  })

  // Filter out unused competencies
  const filteredItems = (competenciesData.value ?? []).filter((item) =>
    usedCompetencyTids.has(item.tid),
  )

  // Build hierarchy as before
  function buildTree(items, parentId = null) {
    return items
      .filter((item) =>
        parentId
          ? item.parent.some((p) => p.tid === parentId)
          : item.parent.length === 0,
      )
      .sort((a, b) => a.weight - b.weight)
      .map((item) => ({
        ...item,
        children: buildTree(items, item.tid),
      }))
  }

  // Flatten hierarchy as before
  function flattenTree(tree, level = 0) {
    return tree.reduce((acc, item) => {
      acc.push({ ...item, level })
      if (item.children.length > 0) {
        acc = acc.concat(flattenTree(item.children, level + 1))
      }
      return acc
    }, [])
  }

  const tree = buildTree(filteredItems)
  return flattenTree(tree)
})

const filteredOrganisations = computed(() => {
  const usedOrganisationTids = new Set()
  allLocationsDataOriginal.value.forEach((location) => {
    location?.organisations?.forEach((org) => usedOrganisationTids.add(org.tid))
  })
  return (organisationsData.value ?? []).filter((org) =>
    usedOrganisationTids.has(org.tid),
  )
})

// Filtered services and regions are not yet implemented, passing empty stubs
const filteredServices = computed(() => {
  return []
})

const filteredRegions = computed(() => {
  return []
})

function centerMapOnLocations(markers) {
  if (!mapInstance || markers.length === 0) return
  const bounds = new google.maps.LatLngBounds()
  markers.forEach((marker) => {
    const position = marker.getPosition()
    if (position) {
      bounds.extend(position)
    }
  })
  mapInstance.fitBounds(bounds, { padding: 100 })
}
</script>

<style lang="postcss">
.slide-fade-enter-active {
  transition: all 0.1s ease-in-out;
}

.slide-fade-leave-active {
  transition: all 0.1s ease-in-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.FilterCollapsed.active {

  &,
  .FilterCollapsed__content {
    overflow: visible;
  }

  &>.FilterCollapsed__content {
    display: block !important;
  }
}

.CustomSelect__options .sub-level {
  padding-left: 1rem;
}
</style>
